import { render, staticRenderFns } from "./ModalLimitedTrialPremium.vue?vue&type=template&id=9627552c&"
import script from "./ModalLimitedTrialPremium.vue?vue&type=script&lang=js&"
export * from "./ModalLimitedTrialPremium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports